module.exports = __webpack_public_path__ + "static/media/banner-mobile.5d642ba2.png";